import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { FiSearch } from 'react-icons/fi';

import styles from './Tools.module.scss';
import ToolCard from '../../components/ToolCard/ToolCard';

export default function Tools() {
  const { tools } = useSelector((state) => state.user);
  const toolsList = tools?.toolsList || [];
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    const list = [...toolsList].sort((a, b) => (a.title || '').localeCompare(b.title || '', 'fr'));
    if (!q) return list;
    return list.filter((t) => {
      const title = (t.title || '').toLowerCase();
      const desc = (t.description || '').toLowerCase();
      const divisions = (t.division || []).join(' ').toLowerCase();
      const type = (t.type || '').toLowerCase();
      return title.includes(q) || desc.includes(q) || divisions.includes(q) || type.includes(q);
    });
  }, [toolsList, search]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2>Outils</h2>
        <div className={styles.search}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher"
          />
          <FiSearch />
        </div>
      </header>
      <div className={styles.grid}>
        {filtered.map((tool) => (
          <ToolCard key={tool._id} tool={tool} />
        ))}
      </div>
    </div>
  );
}
